// extracted by mini-css-extract-plugin
module.exports = {"container":"Statement_container__3Inim","title":"Statement_title__1sn0n","subtitle":"Statement_subtitle__1wCgC","content":"Statement_content__3E-yx"};